const referralToSessionStorage = () => {
  window.onload = () => {
    const queryKey = 'aff'
    const queryValue = getQueryValue(queryKey)
    queryValue && sessionStorage.setItem(queryKey, queryValue)
  }
}

function getQueryValue (queryName) {
  const querySubstr = window.location.search.substring(1)
  const queriesArr = querySubstr.split('&')
  const [queryPair] = queriesArr.filter(queryPair => {
    return queryPair.includes(decodeURIComponent(queryName))
  })
  return queryPair && queryPair.split('=')[1]
}
export default referralToSessionStorage()
